<template>
  <div id="app">
    <div v-if="!mantenimiento">
      <header class="site-navbar align-items-center" role="banner">
        <div class="bg-red-moi col-12 b-navbar container-fluid">
          <b-navbar
            toggleable="lg"
            expand="lg"
            type="dark"
            height="100"
            width="200"
            sticky
            fixed="top"
          >
            <b-navbar-brand class="navbar-brand">
              <router-link
                to="/"
                tag="img"
                src="/images/img_estilos/MMK_Logo.png"
                style="height: 30px; width:100%; object-fit:contain; cursor:pointer;"
                alt="logo"
              ></router-link>
            </b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto ml-center align-items-center">
                <b-nav-item
                  ><router-link
                    class="nav-link"
                    to="/revistas"
                    tag="img"
                    src="/images/img_estilos/barra_revista.svg"
                    style="height: 50px; width: 120px"
                    alt="revista"
                  ></router-link
                ></b-nav-item>
                <b-nav-item
                  ><router-link
                    class="nav-link"
                    to="/anuarios"
                    tag="img"
                    src="/images/img_estilos/barra_anuario.svg"
                    style="height: 50px; width: 120px"
                    alt="anuarios"
                    >Anuarios</router-link
                  ></b-nav-item
                >
                <b-nav-item
                  ><router-link
                    class="nav-link"
                    to="/paquetes"
                    tag="img"
                    src="/images/img_estilos/barra_paquetes.svg"
                    style="height: 50px; width: 120px"
                    alt="paquetes"
                    >Paquetes</router-link
                  ></b-nav-item
                >
                <b-nav-item
                  ><router-link class="nav-link bases-nav" to="/libros"
                    >Libros<span
                      class="icon-bases icon-book"
                    ></span></router-link
                ></b-nav-item>
                <b-nav-item
                  ><router-link class="nav-link bases-nav" to="/faq"
                    >FAQ'S<span
                      class="icon-bases icon-assignment"
                    ></span></router-link
                ></b-nav-item>

                <!-- <b-nav-item
                  ><router-link class="nav-link bases-nav" to="/bases"
                    >Bases #Los7demoi<span
                      class="icon-bases icon-assignment"
                    ></span></router-link
					></b-nav-item>-->
              </b-navbar-nav>
              <!--  nav2- usuario -->
              <b-navbar-nav class="ml-auto align-items-center">
                <b-nav-item v-if="utoken">
                  <router-link to="/profile" style="color: white">
                    Perfil
                  </router-link>
                </b-nav-item>
                <b-nav-item v-if="utoken" @click="logout"
                  ><span style="color: white">Cerrar Sesión</span></b-nav-item
                >
                <b-nav-item v-if="!utoken" v-b-modal.login-modal
                  ><span style="color: white">Iniciar Sesión</span></b-nav-item
                >
                <b-nav-item>
                  <router-link
                    to="/cart"
                    tag="img"
                    src="/images/img_estilos/carrito_blanco.svg"
                    style="height: 25px; width: 25px"
                    alt="carrito"
                  >
                    <span class="count" style="color: white"
                      >({{ $store.state.cart.length }})</span
                    >
                  </router-link>
                </b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
        <div class="container">
          <div class="row">
            <div class="col">
              <div class="alert alert-warning mt-2 d-none">
                Las compras que se realicen entre el 22 de diciembre del 2021 y
                el 2 de enero del 2022, serán despachadas hasta el 3 de enero
                del 2022
              </div>
            </div>
          </div>
        </div>
      </header>
      <vue-snotify></vue-snotify>
      <router-view />
      <img
        src="/images/img_estilos/revistas_logo.svg"
        alt="revistas"
        width="60"
        height="75"
        loading="lazy"
      />
      <div class="footer">
        <LoginForm></LoginForm>
        <RegisterForm></RegisterForm>
        <ResetModal></ResetModal>
      </div>
      <footer
        class="site-footer border-top"
        style="background-image: url(images/backfooter.png)"
      >
        <div class="container">
          <div class="row">
            <div class="col-12 mb-5 mb-lg-0">
              <div class="row">
                <div class="col-12">
                  <h3 class="footer-heading mb-4">Sitios</h3>
                </div>
                <div class="col-6 col-sm-3">
                  <a href="https://www.bbmundo.com">
                    <img
                      class="img-fluid"
                      src="/images/bbmundo.svg"
                      alt="bbmundo"
                      loading="lazy"
                    />
                  </a>
                </div>
                <div class="col-6 col-sm-3">
                  <a href="https://www.revistamoi.com">
                    <img
                      class="img-fluid"
                      src="/images/moi.svg"
                      alt="Revista MOI"
                      loading="lazy"
                    />
                  </a>
                </div>
                <div class="col-6 col-sm-3">
                  <a href="https://www.marthadebayle.com">
                    <img
                      class="img-fluid"
                      src="/images/marthadebayle.svg"
                      alt="Martha Debayle"
                      loading="lazy"
                    />
                  </a>
                </div>
                <div class="col-6 col-sm-3">
                  <a href="https://marthadebaylepodcasts.com/" target="blank">
                    <img
                      class="img-fluid logoPodcast"
                      src="https://mmkgroup-production.s3.amazonaws.com/img/podcastLogoVertical.png"
                      alt="Martha Debayle Podcast"
                      loading="lazy"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-2 mt-1 text-center">
            <div class="col-md-12">
              <p class="p-derechos">
                &copy;Todos los Derechos Reservados de Media Marketing Knowledge
                Group
                <a href="https://www.mmkgroup.com.mx">www.mmkgroup.com.mx</a>
                Prohibida la reproducción total o parcial, incluyendo cualquier
                medio electrónico o magnético
              </p>
              <p class="p-derechos">
                <a class="mx-3" href="/privacity">Política de Privacidad</a>|<a
                  class="mx-3"
                  href="/terms"
                  >Términos y Condiciones</a
                >
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <div class="mantenimiento-main" v-else>
      <header class="site-navbar align-items-center" role="banner">
        <div class="col-12 b-navbar container-fluid">
          <b-navbar
            toggleable="lg"
            expand="lg"
            type="dark"
            height="100"
            width="200"
            sticky
            fixed="top"
          >
            <b-navbar-brand class="navbar-brand">
              <router-link
                to="/"
                tag="img"
                src="/images/img_estilos/barra_suscripcion.svg"
                style="height: 30px"
                alt="suscripcion"
              ></router-link>
            </b-navbar-brand>
          </b-navbar>
        </div>
      </header>
      <p class="mantenimiento-texto">
        Ventana de mantenimiento: Jueves 20 de Mayo - Sábado 22 de Mayo
      </p>
      <img loading="lazy" class="img-mantenimiento" src="/images/mantenimiento.jpg" alt="mantenimiento"/>
      <footer
        class="site-footer border-top"
        style="background-image: url(images/backfooter.png)"
      >
        <div class="container">
          <div class="row">
            <div class="col-12 mb-5 mb-lg-0">
              <div class="row">
                <div class="col-12">
                  <h3 class="footer-heading mb-4">Sitios</h3>
                </div>
                <div class="col-6 col-sm-3">
                  <a href="https://www.bbmundo.com">
                    <img
                      class="img-fluid"
                      src="/images/bbmundo.svg"
                      alt="bbmundo"
                      loading="lazy"
                    />
                  </a>
                </div>
                <div class="col-6 col-sm-3">
                  <a href="https://www.revistamoi.com">
                    <img
                      class="img-fluid"
                      src="/images/moi.svg"
                      alt="Revista MOI"
                      loading="lazy"
                    />
                  </a>
                </div>
                <div class="col-6 col-sm-3">
                  <a href="https://www.marthadebayle.com">
                    <img
                      class="img-fluid"
                      src="/images/marthadebayle.svg"
                      alt="Martha Debayle"
                      loading="lazy"
                    />
                  </a>
                </div>
                <div class="col-6 col-sm-3">
                  <a href="https://marthadebaylepodcasts.com/" target="blank">
                    <img
                      class="img-fluid logoPodcast"
                      src="https://mmkgroup-production.s3.amazonaws.com/img/podcastLogoVertical.png"
                      alt="Martha Debayle Podcast"
                      loading="lazy"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="row pt-2 mt-1 text-center">
            <div class="col-md-12">
              <p class="p-derechos">
                &copy;Todos los Derechos Reservados de Media Marketing Knowledge
                Group
                <a href="https://www.mmkgroup.com.mx">www.mmkgroup.com.mx</a>
                Prohibida la reproducción total o parcial, incluyendo cualquier
                medio electrónico o magnético
              </p>
              <p class="p-derechos">
                <a href="/privacity">Política de Privacidad</a>|<a
                  href="/terms"
                  >Términos y Condiciones</a
                >
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LoginForm from "@/components/LoginForm.vue";
import RegisterForm from "@/components/RegisterForm.vue";
import ResetModal from "@/components/ResetModal.vue";

import { eventBus } from "./events.js";

export default {
  data() {
    return {
      is_login: false,
      utoken: $cookies.get("utoken"),
      mantenimiento: false,
    };
  },
  components: {
    LoginForm,
    RegisterForm,
    ResetModal,
  },
  created() {
    eventBus.$on("tokenSet", (token) => (this.utoken = token));
    if (this.utoken) {
      this.is_login = true;
    }
    $('body').on('contextmenu', 'img', function(e){     return false; });
    

  },
  methods: {
    logout: function () {
      console.info("Deslogeando y borrando cookie");
      this.$store.commit('finishStore');
      this.$cookies.remove("uidmmkg");
      this.$cookies.remove("utoken");
      this.$snotify.info("Se ha salido de su sesión");
      //this.$snotify.info("Se ha deslogeado correctamente");
      this.$router.go();
    },
  },
};
</script>

<style lang="scss">
#app {
  font-family: "TT Norms", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
img{
  image-rendering: -webkit-optimize-contrast;
	image-rendering: optimizequality;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.modal-content {
  border-radius: 0 none;
  -moz-border-radius: 0 none;
  -webkit-border-radius: 0 none;
}

.site-footer {
  //background: url(../images/backfooter.jpg);
  background-color: #f04150 !important;
  color: #fff !important;
}

.site-footer a {
  color: #fff;
  text-decoration: none;
}

.site-footer .footer-heading {
  color: #fff;
}

.site-footer .address,
.site-footer .email,
.site-footer .phone {
  color: #fff;
}

.site-footer .phone a {
  color: #fff;
  text-decoration: none;
}

.navbar-dark .navbar-toggler {
  position: absolute;
  top: 7px;
  right: -10px;
}

.bases-nav {
  color: #fff !important;
  font-size: 20px;
  font-weight: 400;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
}

.icon-bases {
  margin-left: 5px;
  color: #fff !important;
  font-size: 25px;
  font-weight: 400;
}

.p-derechos {
  color: #fff !important;
}

.mantenimiento-texto {
  padding-top: 20px;
  font-size: 28px;
}

.img-mantenimiento {
  max-width: 100%;
}

.bg-red-moi {
  background-color: #f04150;
}

.alert-warning {
  color: #856404 !important;
  background-color: #fff3cd !important;
  border-color: #ffeeba !important;
}
.logoPodcast{
    filter: invert(1);
    max-width: 120px !important;
    margin-top: -20px;
}

@media(max-width:767px){
  .logoPodcast {
    width: 100% !important;
    padding: 10px;
    margin-top: -30px;
  }
}

// Import custom SASS variable overrides, or alternatively
// define your variable overrides here instead
@import "assets/custom-theme.scss";

// Import Bootstrap and BootstrapVue source SCSS files
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap-vue/src/index.scss";
</style>

